<template>
    <!-- 订舱确认 -->
    <div  class="orderPage">
        <div>
            <div class="tit">订舱确认</div>
            <div class="zhuyi">
                <i class="el-icon-info"></i>
                你好，请及时确认订舱信息
            </div>
        </div>
        <div class="jindutiao">
            <el-steps :active="active" >
                <el-step icon="el-icon-success" title="订舱待确认"  :description="parentMessage.two_confirm_time"></el-step>
                <el-step icon="el-icon-success" title="订舱已确认"  :description="parentMessage.three_confirm_time"></el-step>
            </el-steps>
        </div>
        <div class="contenmt">
            <div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            起运港
                        </div>
                        <div class="nr-c">
                            {{parentMessage.pol_name}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            目的港
                        </div>
                        <div class="nr-c">
                            {{parentMessage.pod_name}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            航名/航次
                        </div>
                        <div class="nr-c">
                            {{parentMessage.vessel_voyage}}
                        </div>
                    </div>
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            ETD
                        </div>
                        <div class="nr-c">
                            {{parentMessage.etd}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            ETA
                        </div>
                        <div class="nr-c">
                            {{parentMessage.eta}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            船期
                        </div>
                        <div class="nr-c">
                            {{parentMessage.shipping_date}}天
                        </div>
                    </div>
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            截单时间
                        </div>
                        <div class="nr-c">
                            {{parentMessage.cutoff_bill_of_lading_time}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            进港/开港时间
                        </div>
                        <div>
                            <div class="nr-c">{{parentMessage.cyOpen}}</div>
                            <div class="yimatou">以码头实际时间为准</div>
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            截港时间
                        </div>
                        <div>
                            <div class="nr-c">{{parentMessage.cutoff_enter_the_port_time}}</div>
                            <div class="yimatou">以码头实际时间为准</div>
                        </div>
                    </div>
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            航线
                        </div>
                        <div class="nr-c">
                            {{parentMessage.routeCd}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            船代
                        </div>
                        <div class="nr-c">
                            {{parentMessage.ship_agency}}
                        </div>
                    </div>
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            主单提单号
                        </div>
                        <div class="nr-c">
                            {{parentMessage.mawb_blno}}
                        </div>
                    </div>
                    <div class="nr nryi" v-show="parentMessage.single_type==2">
                        <div class="nr-t">
                            分单提单号
                        </div>
                        <div class="nr-c">
                            {{parentMessage.split_blno}}
                        </div>
                    </div>
                    <!-- <div class="nr nryi">
                        <div class="nr-t">
                            签单方式
                        </div>
                        <div class="nr-c">
                            <span v-if="parentMessage.signing_method==1">电放</span>
                            <span v-if="parentMessage.signing_method==2">正本</span>
                        </div>
                    </div> -->
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            提箱联系人
                        </div>
                        <div class="nr-c">
                            {{parentMessage.suitcase_linkman}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            联系人电话
                        </div>
                        <div class="nr-c">
                            {{parentMessage.suitcase_phone}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            联系人邮箱
                        </div>
                        <div class="nr-c">
                            {{parentMessage.suitcase_email}}
                        </div>
                    </div>
                </div>
            </div>
            <!-- 订单备注 -->
            <div class="neirong">
                <div class="nr">
                    <!-- <div class="nr-t">
                        
                    </div>
                    <div class="nr-c">
                        {{parentMessage.pod_name}}
                    </div> -->
                    <div class="nr-t">
                        提箱地址
                    </div>
                    <p class="nr-c nr-csan">
                        {{parentMessage.suitcase_address}}
                    </p>
                </div>
            </div>

            <div class="neirong">
                <div class="nr">
                    <div class="nr-t">
                        备注内容
                    </div>
                    <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="请输入内容"
                    v-model="form.booking_space_remarks_user">
                    </el-input>
                </div>
            </div>

            <!-- 按钮们 -->
            <div class="sange">
                <!-- <el-button class="yulan">预览</el-button> -->
                <el-button class="daochu" @click="daochu">导出</el-button>
                <el-button v-if="showButton" class="daochu" @click="confirm">订舱确认书收到确认</el-button>
            </div>
        </div>
    </div>
</template>
    
<script>
import { confirmBookingInfo,createBookingNote } from "@/api/api";
export default {
    props:{
        parentMessage:{
            type:Object,
            required:true
        }
    },
    components:{
        
    },
    data() {
        return {
            active: 1,
            form:{
                order_id:'', // --订单id
                booking_space_remarks_user:'', // 订舱备注-用户端
            },
            headers:{
                token: localStorage.getItem('token')
            },
            order_id: sessionStorage.getItem('itemId'),
            showButton:true,
        }
    },
    methods: {
        // 订舱确认
        async confirm(){
            // confirmBookingInfo
            try {
                this.form.order_id=this.parentMessage.order_id

                const res = await confirmBookingInfo(this.form,this.headers)
                if(res.code==1){
                    this.$message({
                        type:'success',
                        message:'订舱确认成功'
                    })
                    this.showButton=false
                    this.active=2
                    this.$emit('from-child', {
                        second: true,
                    })
                }else{
                    this.$message({
                        type:'error',
                        message:res.msg
                    })
                }
            } catch (error) {
                console.log(error,'失败');
            }
        },
        async daochu(){
            try {
                const res = await createBookingNote({
                    order_id: this.$route.query.id
                },this.headers)
                if(res.code==1){
                    // this.form = res.data
                    this.$message({
                        type:'success',
                        message:'导出成功'
                    })
                    const link = document.createElement('a');
                    link.href = res.data.url;
                    link.setAttribute('download', '');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }else{
                    this.$message({
                        type:'error',
                        message:'导出失败'
                    })
                }
            } catch (error) {
                console.log(error,'失败');
            }
        }
    },
    mounted(){
        this.form.booking_space_remarks_user=this.parentMessage.booking_space_remarks_user
        if(this.parentMessage.confirm_status==3 || this.parentMessage.confirm_status==31 || this.parentMessage.confirm_status==4 || this.parentMessage.confirm_status==5){
            this.active=2
            this.showButton=false
        }
    }
}
</script>
    
<style style lang="scss" scoped>

.tit{
    margin-top: 24px;
    font-size: 18px;
    color: #333333;
}

.zhuyi{
    font-size: 14px;
    color: #999999;

    margin-top: 10px;
    margin-bottom: 22px;
    .el-icon-info{
        color: #CCCCCC;
        font-size: 16px;
    }
}

.jindutiao{
    height: 174px;
    background: #F9F9F9;   

    .el-steps{
        padding-left: 32px;
        // height: 650px;
        width: 410px;
        margin: auto;
        padding-top: 48px;
    }
    :deep(.el-steps){
        .el-step__icon{
            background: #F9F9F9;
        }
    }
}

.contenmt{
    background: #fff;
    padding: 20px;

    .con-tit{
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        font-style: normal;
        text-transform: none;

        padding-top: 12px;
        padding-bottom: 24px;

    }

    .neirong{
        display: flex;
        margin-bottom: 20px;
        // justify-content: space-between;
        .nr{
            display: flex;

            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #333333;
            font-style: normal;
            text-transform: none;
        }

        .nryi{
          margin-left: 40px;  
        }


        .nr-t{
            width: 85px;
            height: 20px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #606260;
            line-height: 16px;
            text-align: left;
            font-style: normal;
            text-transform: none;

            margin-top: 10px;
        }

        

        .nr-c{
            width: 260px;
            height: 40px;
            background: #F9F9F9;
            border-radius: 9px 9px 9px 9px;
            
            padding: 10px 12px;

            box-sizing: border-box;
            overflow:hidden;
            display: -webkit-box;  
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis; 
            
        }
        :deep(.el-input){
            width: 260px;
            height: 40px;
            input{
                width: 260px;
                height: 40px;
                background: #F9F9F9;
                border-radius: 8px 8px 8px 8px;
                border: 0;
            }
        }

        :deep(.el-textarea){
            textarea{
                width: 1044px;
                height: 200px;
                background: #F9F9F9;
                border-radius: 8px 8px 8px 8px;
                border: 0;
            }
        }

        .nr-cer{
            height: 120px;
            margin: 0;
            overflow:hidden;
            display: -webkit-box;  
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis; 
        }

        .nr-csan{
            width: 1044px;
            height: 200px;
            margin: 0;
        }

        .chakan{
            text-align: center;

            cursor: pointer;

            color: #0073F5;
        }

        .dongjie{
            display: flex;
            align-items: center;
            span{
                display: inline-block;

                width: 48px;
                height: 20px;
                background: #EDF6FF;
                border-radius: 4px 4px 4px 4px;

                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 10px;
                color: #0073F5;
                line-height: 20px;
                text-align: center;
                font-style: normal;
                text-transform: none;

                margin-left: 8px;
            }
        }

        .con-up{
            display: flex;
            align-items: center;
            justify-content: space-between;
            div{
                display: flex;
                align-items: center;
            }
            i{
                font-size: 16px;
                color: #00b53c;
                margin-right: 9px;
            }

            .name{
                width: 130px;

                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;

                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 12px;
                color: #333333;
                font-style: normal;
                text-transform: none;
            }

            .el-butnm{
                color: #0073F5;
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 12px;
                font-style: normal;
                text-transform: none;

                height: 18px;
                padding: 0;
            }
        }
    }

    .sange{
        text-align: center;
        .quxoia{
            width: 100px;
            height: 40px;
            border-radius: 8px 8px 8px 8px;
            background: #fff;
            font-size: 14px;
            color: #0073F5;
            border: 0;
        }
        .yulan{
            width: 100px;
            height: 40px;
            border-radius: 8px 8px 8px 8px;
            background: #fff;
            font-size: 14px;
            color: #0073F5;
            border: 1px solid #0073F5;
        }
        .daochu{
            min-width: 100px;
            height: 40px;
            border-radius: 8px 8px 8px 8px;
            background: #0073F5;
            font-size: 14px;
            color: #fff;
            border: 0;
        }
    }
}

.table{
    width: 100%;
    border-spacing: 0;

    border-bottom: solid 1px #eee;

    margin-bottom: 20px;
    .theader{
        height: 48px;
        background: #F9F9F9;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        font-style: normal;
        text-transform: none;
        
    }
    .tbody{
        height: 68px;
        background: #fff;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        font-style: normal;
        text-transform: none;
    }
}

.yimatou{
  font-size: 12px;
  color: #999;
}
</style>